import FactoryComponents from '../../../../../../factory/components/FactoryComponents.js';
import {getStaffList, getWorkerByApplica} from "@/api/processManager";
import moment from "moment/moment";
import ProcessWorkPermitSelectPopup from '../../workPermit/ProcessWorkPermitSelectPopup.vue';


const root = {}
export default root
root.name = 'processWorkPermitHD';
root.props = {
	initUserData: Object,
	areaData: Object,
	operaDataCache: Object,
	applicantSelect: Array,
	workerSelect: Array,
	departmentSelect: Array
};
root.components = {
	ProcessWorkPermitSelectPopup
}
root.data = {
	workPermitHdData: {
		isShowProcessWorkPermitSelectPopup: false,
		preWorkInfo: [],
		headerDataCache: {
			//作业证编号
			no: '',
			//作业证名称
			name: new Date().getTime(),
			//计划开始时间
			planStartTime: '',
			//计划结束时间
			planEndTime: '',
			//区域id
			locationId: 0,

			departmentId: null,
			//作业地点
			place: '',
			protectionProduct: '',
			acceptanceEmpId: Number(localStorage.getItem("empId")), // 完工验收人id
			acceptanceOpinion: '',//完收验工意见
			reviewEmpId: Number(localStorage.getItem("empId")), // 复核人id
			reviewOpinion: '',	//复核人意见
			jobExecutorEmpId: 0,//TODO 作业人id
			applyUserId: Number(localStorage.getItem("empId")), // 申请人id
			applyTime: moment().format('YYYY-MM-DD HH:mm:ss'),//申请作业时间
			riskGrade: '0',
			contractorId: null, // 申请单位id
			certificateTypeId: 4,//动火作业id
		},

		//操作的缓存数据
		operaDataCache: {
			name: '',//名称
			//内容
			content: '',
			// 动火人数组
			playFire: [
				{ fm: '', stw: '', wtcNo: '' }
			],
			//危险辨识
			hi: [],
			//安全措施
			sms: [],
			// 2023-02-28新增:动火分析数据
			analysis: [
				{
					time: moment().format('YYYY-MM-DD HH:mm:ss'), // 分析时间
					position: '', // 分析名称
					result: '', // 分析数据
					assayerId: Number(localStorage.getItem("empId")), // 分析人
				}
			],
			mode: '',
			aqjdrId: 0,
			jsjdrId: 0,
			cscsrId: 0,
			jhrId: 0,
			//作业单位负责人
			companyCharger: 0,
			//作业单位负责人意见
			companyChargerComment: '',
			branchCharger: 0,//所在单位负责人
			branchChargerComment: '',//所在单位负责人意见
			safetyDeptUser: 0,//安全管理部门
			safetyDeptUserComment: '',//安全管理部门意见
			fireApprover: 0,//动火审批人
			fireApproverComment: '',//动火审批人意见
			checkTicketUser: 0,//动火前，岗位顶班班长验票
			checkTicketUserComment: ''//动火前，岗位顶班班长验票
		}
	},
}

root.methods = {
	//格式化选择的涉及的其他特殊作业及编号
	formatPreWorkInfo: function () {
		let data = []
		for (var i = 0; i < this.workPermitHdData.preWorkInfo.length; i++) {
			let element = this.workPermitHdData.preWorkInfo[i]
			data.push(`${element.name}(${element.no})`)
		}

		data = data.join(',')
		return data
	},
	//获取选择的涉及的其他特殊作业及编号
	getWorkPermitData: function (e) {
		this.workPermitHdData.preWorkInfo = []
		e.forEach(element => {
			element.selectData.forEach(item => {
				this.workPermitHdData.preWorkInfo.push({ 'no': item.no, 'name': item.name })
			});
		});
		this.$store.commit('setPreWorkInfo', this.workPermitHdData.preWorkInfo)
		this.workPermitHdData.isShowProcessWorkPermitSelectPopup = false

	},
	toOpenWorkCodePopup: function () {
		this.workPermitHdData.isShowProcessWorkPermitSelectPopup = true
	},
	// 回填涉及的其他特殊作业及编号
	backfillPreWorkInfo: function (data, preserveWhenMissing) {
		const hasPreWorkInfo = data && Object.prototype.hasOwnProperty.call(data, 'preWorkInfo');
		if (!hasPreWorkInfo && preserveWhenMissing) {
			this.$store.commit('setPreWorkInfo', this.workPermitHdData.preWorkInfo);
			return;
		}
		let preWorkInfo = hasPreWorkInfo ? data.preWorkInfo : [];
		if (typeof preWorkInfo === 'string') {
			try {
				preWorkInfo = preWorkInfo ? JSON.parse(preWorkInfo) : [];
			} catch (e) {
				preWorkInfo = [];
			}
		}
		if (!Array.isArray(preWorkInfo)) {
			preWorkInfo = [];
		}
		this.workPermitHdData.preWorkInfo = preWorkInfo;
		this.$store.commit('setPreWorkInfo', preWorkInfo);
	},
	// 添加动火人
	addPlayFirer: function () {
		this.workPermitHdData.operaDataCache.playFire.push(
			{ fm: '', stw: '', wtcNo: '' }
		)
	},
	// 删除动火人
	deletePlayFirer: function (index) {
		this.workPermitHdData.operaDataCache.playFire.splice(index, 1)
	},
	// 根据施工单位和作业类型查询动火人
	constructionUnit: function (value) {
		let obj = this.applicantSelect.find(v => {
			return value === v.id
		})
		this.workPermitHdData.operaDataCache.cuName = obj.contrName
		getStaffList().then(res => {
		//getWorkerByApplica({ contractorId: value, certificateTypeId: this.operaDataCache.certificateTypeId }).then(res => {
			this.workPermitHdData.operaDataCache.playFire = [{ fm: '', stw: '', wtcNo: '' }]
			this.workerSelect = res.body.data
		})
	},
	//TODO 选择动火人
	playFirerChange(id) {
		this.workPermitHdData.headerDataCache.jobExecutorEmpId = id;
	},

	// 主要监火人改变
	mainFirerChange(id) {
		let obj = this.initUserData.data((item => {
			return item.id === id
		}))
		this.workPermitHdData.headerDataCache.supervisorId = obj.userId
	},

	returnCacheData: function () {
		if (this.workPermitHdData.operaDataCache.playFire && this.workPermitHdData.operaDataCache.playFire[0] && this.workPermitHdData.operaDataCache.playFire[0].fm) {
			this.workPermitHdData.headerDataCache.jobExecutorEmpId = this.workPermitHdData.operaDataCache.playFire[0].fm;
		}
		return { ...this.workPermitHdData.headerDataCache, firePropsDto: this.workPermitHdData.operaDataCache };
	},

	// 解析业务字段，编辑时按新增页默认字段补齐
	fillPermitData: function (data, preserveWhenMissing) {
		data = data || {};
		this.workPermitHdData.headerDataCache = { ...this.workPermitHdData.headerDataCache, ...data };
		let businessData = {};
		if (data.businessJson) {
			if (typeof data.businessJson === 'object') {
				businessData = data.businessJson;
			} else {
				try {
					businessData = JSON.parse(data.businessJson);
				} catch (e) {
					businessData = {};
				}
			}
		}
		this.workPermitHdData.operaDataCache = { ...this.workPermitHdData.operaDataCache, ...businessData };
		if (!Array.isArray(this.workPermitHdData.operaDataCache.playFire) || !this.workPermitHdData.operaDataCache.playFire.length) {
			this.workPermitHdData.operaDataCache.playFire = [{ fm: '', stw: '', wtcNo: '' }];
		}
		if (!this.workPermitHdData.operaDataCache.playFire[0].fm && this.workPermitHdData.headerDataCache.jobExecutorEmpId) {
			this.workPermitHdData.operaDataCache.playFire[0].fm = this.workPermitHdData.headerDataCache.jobExecutorEmpId;
		}
		if (!Array.isArray(this.workPermitHdData.operaDataCache.analysis) || !this.workPermitHdData.operaDataCache.analysis.length) {
			this.workPermitHdData.operaDataCache.analysis = [{
				time: moment().format('YYYY-MM-DD HH:mm:ss'),
				position: '',
				result: '',
				assayerId: Number(localStorage.getItem("empId")),
			}];
		}
		if (!Array.isArray(this.workPermitHdData.operaDataCache.sms) || !this.workPermitHdData.operaDataCache.sms.length) {
			this.workPermitHdData.operaDataCache.sms = [];
			this.getPermitTypeData();
		}
		this.backfillPreWorkInfo(data, preserveWhenMissing);
	},

	//数据回填
	dataBackfill: function (data) {
		this.fillPermitData(data, true);
	},

	addSamples: function () {
		this.workPermitHdData.operaDataCache.samples.push({});
	},

	// TODO 修改;
	getPermitTypeData: function () {
		let self = this;
		self.componentsMoudel.startPost('/safetyMeasures/list_all', { permitType: 1 }, true).then(res => {
			self.workPermitHdData.operaDataCache.sms = res.body.data;
		});
	},

	// 2023-02-28新增 增加/删除动火分析
	// 添加动火分析
	addHotAnalysis: function () {
		this.workPermitHdData.operaDataCache.analysis.push(
			{
				time: moment().format('YYYY-MM-DD HH:mm:ss'), // 分析时间
				position: '', // 分析名称
				result: '', // 分析数据
				assayerId: Number(localStorage.getItem("empId")), // 分析人
			}
		)
	},
	// 删除动分析
	deleteHotAnalysis: function (index) {
		this.workPermitHdData.operaDataCache.analysis.splice(index, 1)
	}
}

root.mounted = function () {
	if (this.operaDataCache.businessJson) {
		this.fillPermitData(this.operaDataCache);
		this.workPermitHdData.operaDataCache.playFire.map(item => item.fm = Number(item.fm));
	} else {
		this.workPermitHdData.operaDataCache.sms = [];
		this.backfillPreWorkInfo(this.operaDataCache);
		this.getPermitTypeData();
	}
}

FactoryComponents.initComponent(root);
